/**
 * Nama dan penjelasan fitur yang bisa diatur per lembaga di konsol platform.
 *
 * Kuncinya sama dengan FEATURES di backend (src/config/plans.js). Hanya teks
 * tampilan yang ada di sini; apakah sebuah fitur boleh dipakai ditentukan
 * server. Kunci yang belum punya entri di sini tetap tampil memakai namanya
 * sendiri, jadi fitur baru di server tidak hilang dari konsol.
 */
export const FITUR_LEMBAGA = {
  ai_assistant: {
    id: { nama: 'Asisten AI & Knowledge Base', info: 'Memakai Gemini, biayanya ditanggung platform.' },
    en: { nama: 'AI Assistant & Knowledge Base', info: 'Uses Gemini; cost is borne by the platform.' },
  },
  live_translate: {
    id: { nama: 'Terjemahan langsung', info: 'Subtitle sesi secara langsung. Memakai Gemini.' },
    en: { nama: 'Live translation', info: 'Live session subtitles. Uses Gemini.' },
  },
  compliance_report: {
    id: { nama: 'Laporan kepatuhan', info: 'Laporan kepatuhan lanjutan.' },
    en: { nama: 'Compliance reports', info: 'Advanced compliance reports.' },
  },
  custom_game_build: {
    id: { nama: 'Simulasi 3D kustom', info: 'Unggah build sendiri atau susun skenario dari nol.' },
    en: { nama: 'Custom 3D simulations', info: 'Upload your own build or compose a scenario from scratch.' },
  },
  login_advanced: {
    id: { nama: 'Halaman masuk lanjutan', info: 'Gambar latar, tagline, deskripsi, judul, tata letak.' },
    en: { nama: 'Advanced sign-in page', info: 'Cover image, tagline, description, headline, layout.' },
  },
  white_label: {
    id: { nama: 'White-label penuh', info: 'Menyembunyikan identitas platform di halaman masuk.' },
    en: { nama: 'Full white-label', info: 'Hides platform identity on the sign-in page.' },
  },
}

export function teksFitur(key, lang) {
  const e = FITUR_LEMBAGA[key]?.[lang === 'id' ? 'id' : 'en']
  return e || { nama: key, info: '' }
}

/**
 * Pilihan di formulir → nilai yang dikirim: 'paket' = ikut paket (null),
 * 'on' = paksa aktif, 'off' = paksa nonaktif.
 */
export const dariPilihan = (p) => (p === 'on' ? true : p === 'off' ? false : null)
export const kePilihan = (v) => (v === true ? 'on' : v === false ? 'off' : 'paket')
